import { FuseAnimate, FusePageSimple } from '@fuse';
import _ from '@lodash';
import { Input, Paper, Typography, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import CatchErro from 'app/Core/Components/CatchErro/CatchErro';
import PessoaCard from "./PessoaCard";
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as AppActions from 'app/store/actions';
import withReducer from 'app/store/withReducer';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import ProdutoCard from "./ProdutoCard";
import * as Actions from './Store/Actions/EmpresaPessoaProdutoActions';
import reducer from './Store/Reducers/EmpresaPessoaProdutoReducer';

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    },
    paper: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '20px',
        width: '50%'
    },
});


class RelacionamentoModel {
    constructor(data) {
        this.idpessoaformulario = null;
        this.idparent = null;
        this.idpessoaformulariorelacionamento = data.idpessoaformulariorelacionamento;
        this.idpessoa = data.empresa;
        this.tipo = 0;
        this.formulario = {
            "valorservico": data.valor,
            "valor": data.valor,
            "percentual": 100
        }
    }
}

class EmpresaPessoaProduto extends XAPPComponent {

    state = {
        filter: ""
    }

    componentDidMount() {
        this.listFilter();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.EmpresaPessoaProduto.info) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaProduto.info,
                variant: 'success'
            });
            this.props.EmpresaPessoaProduto.info = null;
        }
        if (this.props.EmpresaPessoaProduto.warning) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaProduto.warning,
                variant: 'warning'
            });
            this.props.EmpresaPessoaProduto.warning = null;
        }
        if (this.props.EmpresaPessoaProduto.error) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaProduto.error,
                variant: 'error'
            });
            this.props.EmpresaPessoaProduto.error = null;
        }
    }

    setProduto = (_AItem) => {
        const { idparent, save, xappRouteParams, tipo = "pessoa" } = this.props;
        let AAction = "INSERIR";
        let AObj = new RelacionamentoModel({ ..._AItem, ...xappRouteParams });
        AObj.idparent = idparent;
        AObj.idpessoaformulario = _AItem.idpessoaformulario;

        if (!_.isNull(_AItem.idpessoaformulariorelacionamento)) {
            AAction = "INATIVAR";
            if (_AItem.statusregistro !== 1) {
                AAction = "ATIVAR";
            }
        }

        save(AAction, AObj, xappRouteParams, this.listFilter);
    }

    setPessoa = (_AItem) => {
        const { idparent, save, xappRouteParams, tipo = "pessoa" } = this.props;
        let AAction = "INSERIR";
        let AObj = new RelacionamentoModel({ ..._AItem, ...xappRouteParams });
        AObj.idpessoaformulario = idparent;
        AObj.idparent = _AItem.idpessoaformulario;

        if (!_.isNull(_AItem.idpessoaformulariorelacionamento)) {
            AAction = "INATIVAR";
            if (_AItem.statusregistro !== 1) {
                AAction = "ATIVAR";
            }
        }

        save(AAction, AObj, xappRouteParams, this.listFilter);
    }

    listFilter = () => {
        const { clearReducer, xappRouteParams, idparent, list, tipo = "pessoa" } = this.props;
        clearReducer();
        list("SELECIONAR", xappRouteParams, idparent, tipo);
    }

    handleChange = ev => {
        this.setState(_.set({ ...this.state }, ev.target.name, ev.target.value));
    }

    getArray = (_AFilter = "") => {
        const { data = null } = this.props.EmpresaPessoaProduto;
        let AResponse = [];
        if (!_.isNull(data)) {
            data.forEach(item => {
                if (item.nome.toLowerCase().includes(_AFilter.toLowerCase())) {
                    AResponse.push(item);
                }
            });
        }

        return AResponse;
    }

    render() {
        const { xappRouteParams, EmpresaPessoaProduto, tipo = "pessoa", save, classes, disablePersonFields } = this.props;
        const form = this.state;
        const { data = null } = EmpresaPessoaProduto;
        const AArray = this.getArray(form.filter);
        return (
            <div className="w-full md:p-12">
                <CatchErro
                    url={this.props.match.url}
                >
                    <>
                        <div className="flex flex-col items-center justify-center py-12">
                            <Paper component="div" className={classes.paper}>
                                <Input
                                    placeholder="Filtrar"
                                    className="flex w-full pl-12 py-4"
                                    disableUnderline
                                    fullWidth
                                    name="filter"
                                    value={form.filter}
                                    type='text'
                                    autoComplete="off"
                                    autoFocus
                                    inputProps={{
                                        'aria-label': 'Filtar resultado'
                                    }}
                                    onChange={this.handleChange}
                                />
                            </Paper>
                        </div>
                        {AArray.length > 0 ? (
                            <>
                                {tipo === "produto" && AArray.map(item => (
                                    <PessoaCard
                                        xappRouteParams={xappRouteParams}
                                        card={item}
                                        onChange={this.setPessoa}
                                        save={save}
                                        listFilter={this.listFilter}
                                        disablePersonFields={disablePersonFields}
                                    />
                                ))}
                                {tipo === "pessoa" && (
                                    <div className="flex w-full gap-6 flex-col-reverse md:flex-row">
                                        <div className="p-6 w-full">
                                            <Typography className="flex items-center w-full justify-center mb-6 font-medium">Serviços</Typography>
                                            {AArray.map(item => {
                                                if (_.isNull(item.idpessoaformulariorelacionamento)) {
                                                    return (
                                                        <ProdutoCard
                                                            xappRouteParams={xappRouteParams}
                                                            card={item}
                                                            onChange={this.setProduto}
                                                            save={save}
                                                            listFilter={this.listFilter}
                                                            disablePersonFields={disablePersonFields}
                                                        />
                                                    );
                                                }
                                            })}
                                        </div>
                                        <div className="p-6 w-full">
                                            <Typography className="flex items-center w-full justify-center mb-6 font-medium">Selecionados</Typography>
                                            {AArray.map(item => {
                                                if (!_.isNull(item.idpessoaformulariorelacionamento)) {
                                                    return (
                                                        <ProdutoCard
                                                            xappRouteParams={xappRouteParams}
                                                            card={item}
                                                            onChange={this.setProduto}
                                                            save={save}
                                                            listFilter={this.listFilter}
                                                            disablePersonFields={disablePersonFields}
                                                        />
                                                    );
                                                }
                                            })}
                                        </div>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div className="flex flex-col flex-1 items-center justify-center p-16">
                                <div className="max-w-512 text-center">
                                    <FuseAnimate delay={500}>
                                        <Typography variant="h6" color="textSecondary" className="mb-16">
                                            {"Não existem registros cadastrados!"}
                                        </Typography>
                                    </FuseAnimate>
                                </div>
                            </div>
                        )}
                    </>
                </CatchErro>
            </div>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        save: Actions.save,
        showMessage: AppActions.showMessage,
        clearReducer: Actions.clearReducer,
    }, dispatch);
}

function mapStateToProps({ EmpresaPessoaProduto }) {
    return {
        EmpresaPessoaProduto: EmpresaPessoaProduto,
    }
}

export default withReducer('EmpresaPessoaProduto', reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaProduto))));
